import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Place } from './place';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { DeviceOptionType, PlaceType } from '../types';

const _schema = {
    "name": "PLACEOPT",
    "fields": [
        { name: "place", type: "objid" },
        { name: "opkey", type: "string" },
        { name: "value", type: "string" },
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "options", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: "<", target: "DEVICEOPT", by: "option", name: "device", reason: "devices", child: true, class: DeviceOptionType },
    ]
} as const;

const _PlaceOptionClass = CreateObject(_schema);
if (!_PlaceOptionClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PlaceOption extends _PlaceOptionClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PlaceOption {
        return this._Copy(store) as PlaceOption;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'options' && related instanceof Place){
            if (related === this.place){
                related.AddOption(this);
            }
        }
    }
}
